pageId = 'page-invoice-new'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  initForm($page)

initForm = ($page) ->
  normalInvoiceType = 0
  $registerPhoneField = $page.find('[name="invoice[register_phone]"]')
  $registerPhoneAreaCodeField = $page.find('[name="register_phone_area_code"]')
  $registerPhoneNumberField = $page.find('[name="register_phone_number"]')

  if parseInt($page.find('[name="invoice[invoice_type]"]:checked').val()) == normalInvoiceType
    disableSpecialInvoiceFields($page)
  else
    enableSpecialInvoiceFields($page)

  $page
    .on 'change', '[name="invoice[invoice_type]"]', (e) ->
      return unless $(e.currentTarget).is(':checked')
      $invoiceTypeField = $page.find('[name="invoice[invoice_type]"]:checked')
      if parseInt($invoiceTypeField.val()) == normalInvoiceType
        disableSpecialInvoiceFields($page)
      else
        enableSpecialInvoiceFields($page)

    .on 'change', '[name="register_phone_area_code"], [name="register_phone_number"]', ->
      areaCode = $registerPhoneAreaCodeField.val()
      number = $registerPhoneNumberField.val()
      $registerPhoneAreaCodeField.val(areaCode.trim())
      $registerPhoneNumberField.val(number.trim())
      areaCode = $registerPhoneAreaCodeField.val()
      number = $registerPhoneNumberField.val()

      if areaCode || number
        phone = "#{areaCode}-#{number}"
      else
        phone = ""
      $registerPhoneField.val(phone)

    .on 'validate', '.register-phone-area-code-field', (e, val, args) ->
      $field = $(e.target)
      valid = /^0[1-9]\d{1,2}$/.test(val)

      {
        valid: valid
        errorMsg: if valid then undefined else $field.data('validate-msg')
      }

enableSpecialInvoiceFields = ($page) ->
  $page
    .find('.for-special-invoice').removeClass('hidden')
    .find('input')
      .prop('disabled', false)

disableSpecialInvoiceFields = ($page) ->
  $page
    .find('.for-special-invoice').addClass('hidden')
    .find('input')
      .prop('disabled', true)
